module.exports = __webpack_public_path__ + "static/media/productImg.901456d0.svg";